// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ec38eadc","160":"5ce3fb59","208":"e8d5bdfb","293":"19bcd7e7","516":"095acf74","519":"aa0257c3","917":"95883f30","946":"2188b241"}[chunkId] + ".chunk.js";
};